// extracted by mini-css-extract-plugin
export default {"Container":"streamOperationIndicator_Container__WQfM7"};